/**
 * Temporary page to preview icon styles
 * Navigate to /icon-preview to see them
 */

import { IconStylePreview } from '@/components/icons/RouteIdentificationIcons';

export const IconPreviewPage = () => {
  return <IconStylePreview />;
};

export default IconPreviewPage;
